import { LoadingButton } from '@mui/lab';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnnouncementState, createAnnouncement, resetCreateAnnouncementState, selectAnnouncementsState } from '../sagas/announcementSlice';
import { Alert, AlertColor, Snackbar } from '@mui/material';
import { AnnouncementMethods, CreateAnnouncementDto, CreateAnnouncementDtoStatusEnum } from '@inosio/payments-sdk';
import { useHistory } from 'react-router';
import { selectPropertyGroupDetailsState } from '../../../shared/sagas/propertyGroups/propertyGroupsSlice';

export interface CreateNewAnnouncementButtonProps {}

export const CreateNewAnnouncementButton = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { propertyGroups } = useSelector(selectPropertyGroupDetailsState);
  const { isCreatingAnnouncement, isCreatingAnnouncementSuccess, announcementDetail, isCreatingAnnouncementFailed, CreateAnnouncementError }: AnnouncementState = useSelector(selectAnnouncementsState);
  const [snackBar, setSnackBar] = useState<{ severity: AlertColor; message?: string } | null>(null);

  const handleCreateNew = () => {
    const defaultPropertyGroup = propertyGroups.find((propertyGroup) => propertyGroup.PropertyGroupType === 'Default');

    if (defaultPropertyGroup) {
      const newAnnouncement: CreateAnnouncementDto = {
        AnnouncementMethod: AnnouncementMethods.Email,
        BelongsToUuid: defaultPropertyGroup?.Uuid,
        Status: CreateAnnouncementDtoStatusEnum.Draft,
        PropertyGroupScope: '*',
      };
      dispatch(createAnnouncement(newAnnouncement));
    } else {
      setSnackBar({
        severity: 'info',
        message: 'No default property group found.',
      });
    }
  };

  useEffect(() => {
    if (isCreatingAnnouncementSuccess && announcementDetail.TemplateUuid) {
      dispatch(resetCreateAnnouncementState());
      history.replace(`/pmui/announcements/${announcementDetail.TemplateUuid}/details`);
    }
  }, [isCreatingAnnouncementSuccess, announcementDetail]);

  useEffect(() => {
    if (isCreatingAnnouncementFailed && CreateAnnouncementError.statusCode) {
      setSnackBar({
        severity: 'error',
        message: CreateAnnouncementError.message,
      });
      dispatch(resetCreateAnnouncementState());
    }
  }, [isCreatingAnnouncementFailed, CreateAnnouncementError]);

  const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBar(null);
  };
  return (
    <Fragment>
      <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={!!snackBar} autoHideDuration={4000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity={snackBar?.severity}>
          {snackBar?.message}
        </Alert>
      </Snackbar>
      <LoadingButton loading={isCreatingAnnouncement} variant="accountManagement" sx={{ height: 46, width: 152, fontSize: '15px', ml: 2, borderRadius: 24 }} onClick={handleCreateNew}>
        Create New
      </LoadingButton>
    </Fragment>
  );
};
